// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__kOIpU","text":"style_text__-KP3r","actions":"style_actions__e+sH3","actions_btn":"style_actions_btn__x3OIE"};